export default {
  id: "watchdog",
  name: "Scout",
  shortName: "Scout",
  description: "Local market intelligence",
  icon: "radar",
  color: "#D97706",
  roles: ["super_admin", "admin", "corporate"],
  css: "styles/apps/watchdog.css",
  nav: [],
  defaultView: "feed",
};
